<template>
  <div class="dispatch">
    <ScreenPanel :isExpand="isLeft">
      <ScreenBox title="货物类型">
        <GoodsType />
      </ScreenBox>
      <!-- 已调度的当前月台排队情况 -->
      <ScreenBox title="月台排队情况">
        <dispatch-table :columnData="platformColumnData" :table-data="platformTableData" />
      </ScreenBox>
    </ScreenPanel>
    <ScreenPanel :isExpand="isRight" position="right">
      <!-- 已调度的 -->
      <ScreenBoxClick title="待装卸车辆情况" menuCode="130201">
        <ConditionsVehicles />
      </ScreenBoxClick>
      <ScreenBox title="各月台装卸货进展">
        <dispatch-table :columnData="evolveColumnData" :table-data="evolveTableData" />
      </ScreenBox>
    </ScreenPanel>
  </div>
</template>

<script>
import ScreenPanel from "@ISS/situation/components/ScreenPanel";
import ScreenBox from "@ISS/situation/components/ScreenBox";
import ScreenBoxClick from "../components/ScreenBoxClick.vue";
import GoodsType from "@ISS/situation/components/GoodsType";
import DispatchTable from "@ISS/situation/components/dispatchTable";
import ConditionsVehicles from "@ISS/situation/components/ConditionsVehicles";
import api from "../api";
export default {
  name: "Dispatch",
  components: {
    ConditionsVehicles,
    DispatchTable,
    GoodsType,
    ScreenBox,
    ScreenBoxClick,
    ScreenPanel,
  },
  data() {
    return {
      isLeft: false,
      isRight: false,
      platformColumnData: [
        {
          label: "车牌号",
          prop: "vehicleNumber",
          width: 100,
        },
        {
          label: "司机",
          prop: "driverName",
        },
        {
          label: "冷库",
          prop: "storageName",
        },
        {
          label: "月台号",
          prop: "platformCode",
        },
        {
          label: "月台排号",
          prop: "order",
        },
      ],
      platformTableData: [],
      evolveColumnData: [
        {
          label: "车牌号",
          prop: "vehicleNumber",
          width: 100,
        },
        {
          label: "冷库",
          prop: "storageName",
        },
        {
          label: "月台号",
          prop: "platformCode",
        },
        {
          label: "作业类型",
          prop: "operateTypeName",
        },
        {
          label: "状态",
          prop: "workStatusName",
        },
      ],
      evolveTableData: [],
    };
  },
  beforeDestroy() {
    this.$map.hideMap2D();
  },
  created() {
    this.queryInfo();
  },
  mounted() {
    this.isLeft = true;
    this.isRight = true;
    this.$map.showMap2D();
    // this.$map.MapInstance2D.addTextLayer('11', marker, null, 10)
  },
  methods: {
    queryInfo() {
      this.queryVehicleLineUp();
      this.queryPlatformLoadedAndUnloaded();
    },
    async queryVehicleLineUp() {
      const { success, returnObj } = await this.$fetch(
        api.dispatch.queryVehicleLineUp
      );
      if (success) {
        this.platformTableData = returnObj;
      }
    },
    async queryPlatformLoadedAndUnloaded() {
      const { success, returnObj } = await this.$fetch(
        api.dispatch.queryPlatformLoadedAndUnloaded
      );
      if (success) {
        this.evolveTableData = returnObj;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dispatch {
  height: 100%;
  width: 100%;
}
</style>
